import React, { Fragment, useCallback, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { generatePath, useRouteMatch, Redirect } from 'react-router';

import { translate } from 'services/i18nService';
import Button from 'components/Button/Button';
import Modal from 'components/Modal/Modal';
import { privateRoutes } from 'enum/routeDefinitions';

import styles from './DMCASubmitModal.css';


function DMCASubmitModal({ close, modalType }) {
  const { params } = useRouteMatch('/:username');

  const [shouldRedirect, setShouldRedirect] = useState(false);

  const handleClose = useCallback((event) => {
    if (modalType === 'SUCCESS') {
      setShouldRedirect(true);
    } else {
      close(event);
    }
  }, [close, modalType]);

  const content = useMemo(() => {
    if (modalType === 'SUCCESS') {
      return (
        <Fragment>
          <h3>{translate('profile.profile.dmca.overlay.request.submitted')}</h3>
          <h5>{translate('profile.profile.dmca.overlay.thank.you')}</h5>
          <p>{translate('profile.profile.dmca.overlay.success')}</p>
        </Fragment>
      );
    }

    return (
      <Fragment>
        <h3>{translate('profile.profile.dmca.overlay.request.submit.error')}</h3>
        <p>{translate('profile.profile.dmca.overlay.error')}</p>
      </Fragment>
    );
  }, [modalType]);

  if (shouldRedirect) {
    const { username } = params;
    const broadcasterDahsboard = privateRoutes.settings.performerHub.root;
    const path = generatePath(broadcasterDahsboard, { username });

    return <Redirect to={path} />;
  }

  return (
    <Modal
      className={styles.modalClass}
      close={handleClose}
      showClose={false}
      size="large"
      type="full"
    >
      {content}
      <Button
        label={translate('account.button.close')}
        onClick={handleClose}
      />
    </Modal>
  );
}

DMCASubmitModal.propTypes = {
  close: PropTypes.func.isRequired,
  modalType: PropTypes.string.isRequired,
};

export default DMCASubmitModal;
